
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Head, Steps, themes } from "mdx-deck";
import var_hls from "./images/var_hls.svg";
import timeRange from "./images/timeRange.png";
import mp4mp3 from "./images/mp4mp3.png";
import vue from "./images/vue.svg";
import angular from "./images/angular.svg";
import react from "./images/react.svg";
import events from "./images/mediaEvents.png";
import volumeTest from "./images/volumeTest.png";
import goku from "./images/goku.gif";
import ie from "./videos/ie.mp4";
import mediaFullFlow from "./videos/mediaFullFlow.mp4";
export const theme = themes.notes;
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  theme
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Head mdxType="Head">
  <title>VAR MEDIA = MSE</title>
    </Head>
    <h1>{`👨🏻‍💻 VAR MEDIA = MSE 🎉`}</h1>
    <h2><a style={{
        textDecoration: 'none'
      }} href="https://namnguyen.design/" target="\_blank">{`Nam Nguyen`}</a></h2>
    <hr></hr>
    <h1>{`Glossary`}</h1>
    <ul>
  <h3>⚛️ Frameworks</h3>
  <h3>🔮 MSE</h3>
  <h3>🎥 Video</h3>
  <h3>🎵 Audio</h3>
    </ul>
    <hr></hr>
    <h1>{`Acceptance criteria`}</h1>
    <div style={{
      height: "80%"
    }}>
  <Steps mdxType="Steps">
    <h3>🍀 Accessibility</h3>
    <h3>☂️ Sync data between framework and platform</h3>
    <h3>🍴 Avoid tighly coupling</h3>
    <h3>🥋 Flexibility</h3>
    <h3>⛓ Testable</h3>
    <h3>🎱 IE11 loading indicator</h3>
    <h3>📖 Documentation</h3>
    <h3>🎥 Mp4 Mp3 🎵</h3>
  </Steps>
    </div>
    <hr></hr>
    <h1>{`🔥 Architecture 🔥`}</h1>
    <img src={var_hls} alt="var_hls.svg" border="0" />
    <hr></hr>
    <h2>{`🎪 Events 🎪`}</h2>
    <img style={{
      height: "80%",
      width: "90%",
      objectFit: "contain"
    }} src={events} alt="events.png" border="0" />
    <hr></hr>
    <h2>{`🤜 Testability 🤛`}</h2>
    <img style={{
      height: "80%",
      width: "90%",
      objectFit: "contain"
    }} src={volumeTest} alt="volumeTest.png" border="0" />
    <hr></hr>
    <h2>{`🕶 Check loading 👓`}</h2>
    <img style={{
      height: "80%"
    }} src={timeRange} alt="var_hls.svg" border="0" />
    <hr></hr>
    <h2>{`😎 IE11 in action 😎`}</h2>
    <video controls style={{
      height: "80%"
    }} src={ie} />
    <hr></hr>
    <h2>{`🎥 MP4 MP3 🎵`}</h2>
    <img style={{
      height: "80%"
    }} src={mp4mp3} alt="mp4mp3.png" border="0" />
    <hr></hr>
    <h2>{`👮‍♂️ AXON VIDEO 👮`}</h2>
    <video controls style={{
      height: "80%"
    }} src={mediaFullFlow} />
    <hr></hr>
    <h2>{`👉 Frameworks Implementation 👈`}</h2>
    <div style={{
      display: "flex",
      height: "80%",
      justifyContent: "center",
      alignItems: "center"
    }}>
  <a style={{
        width: "33%"
      }} href="https://vue-hlsjs.netlify.app/" target="_blank">
    <img src={vue} alt="vue.svg" border="0" />
  </a>
  <a style={{
        width: "33%"
      }} href="https://angular-hlsjs.netlify.app/" target="_blank">
    <img src={angular} alt="angular.svg" border="0" />
  </a>
  <a style={{
        width: "33%"
      }} href="https://react-rock-hls.netlify.app/" target="_blank">
    <img src={react} alt="react.svg" border="0" />
  </a>
    </div>
    <hr></hr>
    <h1>{`Thanks for staying`}</h1>
    <img style={{
      height: "80%"
    }} src={goku} alt="goku.gif" border="0" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;